// Mock product data for design mode using actual product images
export const mockProducts = [
  {
    Id: 1,
    Name: "Heart Pop Socket",
    Price: 15.99,
    PictureUrl1: "/media/HeartPopSocket1.jpg",
    PictureUrl2: "/media/HeartPopSocket2.png",
    PictureUrl3: "/media/HeartPopSocket2.png",
    PictureUrl4: "/media/HeartPopSocket.jpg",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 2,
    Name: "Coffee Mug",
    Price: 12.99,
    PictureUrl1: "/media/KelseyMug1.jpg",
    PictureUrl2: "/media/KelseyMug2.png",
    PictureUrl3: "/media/KelseyMug2.png",
    PictureUrl4: "/media/KelseyMug.jpg",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 3,
    Name: "Heart Puzzle",
    Price: 22.99,
    PictureUrl1: "/media/Heart Puzzle 1.png",
    PictureUrl2: "/media/Heart Puzzle 2.png",
    PictureUrl3: "/media/Heart Puzzle 3.png",
    PictureUrl4: "/media/Heart Puzzle 4.png",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 4,
    Name: "Canvas Tote Bag",
    Price: 16.99,
    PictureUrl1: "/media/CanvasBag1.png",
    PictureUrl2: "/media/CanvasBag2.png",
    PictureUrl3: "/media/CanvasBag2.png",
    PictureUrl4: "/media/CanvasBag3.png",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 5,
    Name: "Mylar Balloon",
    Price: 18.99,
    PictureUrl1: "/media/MylarBalloon1.png",
    PictureUrl2: "/media/MylarBalloon2.png",
    PictureUrl3: "/media/MylarBalloon3.png",
    PictureUrl4: "/media/MylarBalloon4.png",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 6,
    Name: "Pop Socket",
    Price: 15.99,
    PictureUrl1: "/media/PopSocket1.jpg",
    PictureUrl2: "/media/PopSocket2.png",
    PictureUrl3: "/media/PopSocket2.png",
    PictureUrl4: "/media/KelseyRyanPOPSOCKET.JPG",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 7,
    Name: "White V-Neck T-Shirt",
    Price: 24.99,
    PictureUrl1: "/media/WhiteVNeck1.jpg",
    PictureUrl2: "/media/WhiteVNeck2.png",
    PictureUrl3: "/media/WhiteVNeck2.png",
    PictureUrl4: "/media/shirt-guy.jpg",
    IsActive: true,
    IsSoldOut: false
  },
  {
    Id: 8,
    Name: "Bar Coasters",
    Price: 14.99,
    PictureUrl1: "/media/bar-coasters-hero.jpg",
    PictureUrl2: "/media/bar-coasters-hero.jpg",
    PictureUrl3: "/media/bar-coasters-hero.jpg",
    PictureUrl4: "/media/bar-coasters-hero.jpg",
    IsActive: true,
    IsSoldOut: false
  }
];

// Helper function to get a product by name
export const getProductByName = (name) => {
  return mockProducts.find(p => p.Name === name);
};

// Helper function to get a product by ID
export const getProductById = (id) => {
  return mockProducts.find(p => p.Id === parseInt(id));
};

